module.exports = __webpack_public_path__ + "img/logo-min.945037c0.svg";